const ROOT = '/empresas'

const path = Object.freeze({
  privatePath: {
    RECOMENDADOS: `${ROOT}/recomendados`,
    AVISO: `${ROOT}/aviso`,
    AVISOS: `${ROOT}/avisos`,
    SELECTOR_AVISO: `${ROOT}/aviso/productos`,
    AVISO_PUBLICACION: `${ROOT}/aviso/publicacion-productos`,
    LISTADO_AVISOS: `${ROOT}/avisos/listado`,
    LISTADO_AVISOS_BORRADORES: `${ROOT}/avisos/listado?estadoTipo=borradores`,
    CV_RECOMENDADO: `${ROOT}/recomendado/:idAviso/cv/:idCv`,
    JOBI: `${ROOT}/jobi`,
    DASHBOARD: `${ROOT}/dashboard`,
    NEW_ECOMMERCE: `${ROOT}/compra-online`,
    LANDING_PAGO_EXITOSO: `${ROOT}/compra-online/pagoExitoso/:idOrder`,
    LANDING_PAGO_FALLIDO: `${ROOT}/compra-online/pagoFallido/:idOrder`,
    LANDING_PAGO_PENDIENTE: `${ROOT}/compra-online/pagoPendiente/:idOrder`,
    DATOS_FACTURACION: `${ROOT}/compra-online/datos-facturacion`,
    TABLERO_SELECCION: `${ROOT}/tablero-seleccion/:idAviso`,
    CURRICULUM: `${ROOT}/premium/:idPool/cv/:idCv`,
    TALENT_POOL: `${ROOT}/premium`,
    FUTURE_TALENTS: `${ROOT}/jovenes-talentos`,
    ADMIN_USUARIOS: `${ROOT}/administracion-usuarios`,
    USUARIOS_LOG: `${ROOT}/log-acceso-usuarios`,
    PERFIL_USUARIO: `${ROOT}/perfil-usuario`,
    COMPANY_PROFILE: `${ROOT}/perfil-empresa`,
    RESUMEN_CUENTA: `${ROOT}/resumen-cuenta`,
    SELECTA: `${ROOT}/selecta`,
    PANEL: `${ROOT}/inicio`,
    ESTADISTICAS: `${ROOT}/estadisticas-generales`,
    BUSQUEDA_EN_BASE: `${ROOT}/busqueda-perfiles`,
    MENSAJES: `${ROOT}/mensajes`,
  },
  publicPath: {
    HOME: ROOT,
    SIGN_UP: `${ROOT}/registro`,
    SIGN_IN: `${ROOT}/ingreso`,
    FORGOT_PASSWORD: `${ROOT}/recupero-clave`,
    CHANGE_PASSWORD: `${ROOT}/cambio-clave`,
    POLICY: `${ROOT}/politicas`,
  },
})

export default path
